<template>
  <RecycoGenericInputComponent :label="label" :icon="icon" :validate="validate" :value="value">
    <input :value="value" @input="input" v-bind="$attrs">
  </RecycoGenericInputComponent>
</template>

<script>
  import RecycoGenericInputComponent from './RecycoGenericInputComponent.vue';

  export default {
    name: 'recyco-input',
    components: {
      RecycoGenericInputComponent,
    },
    props: {
      label: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
      },
      validate: {
        type: Function,
        default: () => null,
      },
      value: {
        default: undefined,
      },
    },
    methods: {
      input(event) {
        const { value } = event.target;
        this.$emit('input', value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  input {
    width: 100%;
    box-sizing: border-box;

    font: inherit;
    padding: .4375em .75em;
    line-height: 1.5;
    color: inherit;
    background-color: white;
    // border: 1px solid $color-gray-ultra-light; // TODO
    border: 1px solid #aaaaaa;
    // will-change: border-color, box-shadow;
    will-change: border-color;
    border-radius: 1.5em;
    box-shadow: none;
    outline: 0;
    // transition: box-shadow .25s cubic-bezier(.27,.01,.38,1.06), border .25s cubic-bezier(.27,.01,.38,1.06), -webkit-box-shadow .25s cubic-bezier(.27,.01,.38,1.06);
    transition: border .25s cubic-bezier(.27,.01,.38,1.06);

    &:enabled:hover {
      // border-color: $color-gray-light; // TODO
      border-color: 1px solid #cccccc;
    }

    &:enabled:focus {
      border-color: var(--color-primary);
      // box-shadow: 0 .313rem .719rem rgba($color-primary, .1), 0 .156rem .125rem rgba(0, 0, 0, .06);
    }

    &:disabled {
      cursor: not-allowed;
      // color: $color-gray-light; // TODO
      color: #cccccc
    }
  }
</style>
